<template>
  <v-card class="pa-4 text-center">
    <h2>Remover cliente</h2>
    <p>Tem certeza de que deseja remover este cliente?</p>

    <p>
      OBS: se houver algum pedido para este cliente, ele não poderá ser
      deletado!
    </p>

    <div class="d-flex">
      <v-btn class="secondary-button ma-1" @click="$emit(`close`)">
        Cancelar
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn class="primary-button ma-1" @click="submit" :loading="loading">
        Remover
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
export default {
  name: `RemoveClient`,

  props: {
    clientProp: {},
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
    };
  },

  methods: {
    submit() {
      this.loading = true;
      this.apiService
        .delete(`client/delete/client/${this.clientProp.id}`)
        .then(() => {
          this.loading = false;
          this.$toast.success(`Cliente removido com sucesso!`);
          this.$emit(`confirm`);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
